module.exports = __webpack_public_path__ + "static/carbon-36049e90147fa9cd62120b2c93df96f9.jpg";